<template>
  <div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { HM_MOBILE_DASHBOARD_PATH, HM_PC_DASHBOARD_PATH } from '@/constant/common'
import { deviceType } from '@/utils/common'

export default {
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('hm', ['setToken']),
    initPage () {
      const token = this.$route.query.hm_token
      const backUrl = this.$route.query.back_url
      if (token) {
        this.setToken(token)
        if (backUrl) {
          window.location.href = backUrl
        } else {
          window.location.href = deviceType.isPc ? HM_PC_DASHBOARD_PATH : HM_MOBILE_DASHBOARD_PATH
        }
      } else {
        this.$router.push({ path: '/v-admin/hm/login', query: { back: backUrl } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
